import React, { useState } from 'react';
import {
  Form, Input, Button, Upload, message, Row, Col, Breadcrumb, Grid, Card, Avatar
} from 'antd';
import {
  UploadOutlined,
  RightOutlined,
  PlusOutlined,
  AppstoreOutlined,
  PictureOutlined,
  SaveOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { getCategories } from '../../common/services';

const AjoutCategorie = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const screens = Grid.useBreakpoint();
  const isMobile = !screens.sm;
  const controlSize = isMobile ? 'small' : 'middle';

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('name', values.name);

      if (values.image && values.image.length) {
        formData.append('image', values.image[0].originFileObj);
      }

      await getCategories.post(formData);
      message.success('Catégorie ajoutée avec succès');
      navigate('/dashboard/categories');
    } catch (error) {
      console.error(error);
      message.error("Erreur lors de l'ajout de la catégorie");
    } finally {
      setIsSubmitting(false);
    }
  };

  // normalise la valeur Upload -> fileList
  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

  // Preview image
  const handlePreview = (file) => {
    if (file.originFileObj) {
      const reader = new FileReader();
      reader.onload = (e) => setPreviewImage(e.target.result);
      reader.readAsDataURL(file.originFileObj);
    }
  };

  const handleUploadChange = ({ fileList }) => {
    if (fileList.length > 0) {
      handlePreview(fileList[0]);
    } else {
      setPreviewImage(null);
    }
  };

  return (
    <div className="content-wrapper">
      <style>
        {`
          .form-card {
            border-radius: 16px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          }
          .form-card .ant-form-item-label > label {
            font-weight: 500;
            color: #262626;
          }
          .ant-upload-drag {
            border-radius: 12px !important;
          }
          .ant-upload-drag:hover {
            border-color: #2f54eb !important;
          }
        `}
      </style>

      <div className="container-xxl flex-grow-1" style={{ paddingTop: 8, paddingLeft: 24, paddingRight: 24 }}>
        {/* Breadcrumb */}
        <Breadcrumb
          separator={<RightOutlined style={{ fontSize: 12, color: '#8c8c8c' }} />}
          style={{ marginBottom: 12, marginTop: 0, paddingTop: 0 }}
        >
          <Breadcrumb.Item>
            <Link to="/dashboard" style={{ color: '#2f54eb' }}>Accueil</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/dashboard/categories" style={{ color: '#2f54eb' }}>Gestion Services</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span style={{ color: '#595959' }}>Ajouter une catégorie</span>
          </Breadcrumb.Item>
        </Breadcrumb>

        {/* Formulaire */}
        <Card className="form-card" bodyStyle={{ padding: isMobile ? 16 : 32 }}>
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSubmit}
            size={controlSize}
          >
            <Row gutter={[24, 16]}>
              {/* Colonne gauche - Informations */}
              <Col xs={24} md={12}>
                <Card
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <AppstoreOutlined style={{ color: '#2f54eb' }} />
                      <span>Informations de la catégorie</span>
                    </div>
                  }
                  style={{ borderRadius: 12, height: '100%' }}
                  headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                  <Form.Item
                    name="name"
                    label="Nom de la catégorie"
                    rules={[{ required: true, message: 'Veuillez entrer le nom de la catégorie' }]}
                  >
                    <Input
                      placeholder="Ex : Yango Taxi, Yango Delivery..."
                      style={{ borderRadius: 8 }}
                      prefix={<AppstoreOutlined style={{ color: '#bfbfbf' }} />}
                    />
                  </Form.Item>

                  <div style={{
                    padding: 16,
                    background: '#f6f8fa',
                    borderRadius: 8,
                    marginTop: 16
                  }}>
                    <h4 style={{ margin: '0 0 8px 0', color: '#595959' }}>
                      Conseils
                    </h4>
                    <ul style={{ margin: 0, paddingLeft: 20, color: '#8c8c8c', fontSize: 13 }}>
                      <li>Utilisez un nom clair et descriptif</li>
                      <li>Évitez les abréviations</li>
                      <li>Le nom doit être unique</li>
                    </ul>
                  </div>
                </Card>
              </Col>

              {/* Colonne droite - Image */}
              <Col xs={24} md={12}>
                <Card
                  title={
                    <span>
                      <PictureOutlined style={{ color: '#2f54eb', marginRight: 8 }} />
                      Image de la catégorie
                    </span>
                  }
                  style={{ borderRadius: 12, height: '100%' }}
                  headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                  <Form.Item
                    name="image"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[{ required: true, message: 'Veuillez sélectionner une image' }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Upload.Dragger
                      beforeUpload={() => false}
                      maxCount={1}
                      accept="image/*"
                      onChange={handleUploadChange}
                      showUploadList={false}
                      style={{
                        padding: 20,
                        borderRadius: 12,
                        border: '2px dashed #d9d9d9',
                        background: '#fafafa'
                      }}
                    >
                      {previewImage ? (
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: 120
                        }}>
                          <img src={previewImage} alt="Preview" style={{ maxHeight: 120, maxWidth: '100%', objectFit: 'contain' }} />
                        </div>
                      ) : (
                        <div style={{ textAlign: 'center' }}>
                          <UploadOutlined style={{ fontSize: 32, color: '#2f54eb' }} />
                          <p style={{ marginTop: 12, marginBottom: 4, color: '#595959' }}>
                            Cliquez ou glissez une image ici
                          </p>
                          <p style={{ margin: 0, color: '#bfbfbf', fontSize: 12 }}>
                            PNG, JPG jusqu'à 5MB
                          </p>
                        </div>
                      )}
                    </Upload.Dragger>
                  </Form.Item>

                  {previewImage && (
                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                      <Button
                        type="link"
                        danger
                        onClick={() => {
                          setPreviewImage(null);
                          form.setFieldValue('image', []);
                        }}
                      >
                        Supprimer l'image
                      </Button>
                    </div>
                  )}
                </Card>
              </Col>
            </Row>

            {/* Boutons d'action */}
            <Row style={{ marginTop: 24 }}>
              <Col xs={24}>
                <div style={{
                  display: 'flex',
                  justifyContent: isMobile ? 'stretch' : 'flex-end',
                  gap: 12,
                  flexDirection: isMobile ? 'column' : 'row'
                }}>
                  <Link to="/dashboard/categories">
                    <Button
                      size={controlSize}
                      style={{
                        borderRadius: 8,
                        width: isMobile ? '100%' : 'auto'
                      }}
                    >
                      Annuler
                    </Button>
                  </Link>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                    icon={<SaveOutlined />}
                    size={controlSize}
                    style={{
                      borderRadius: 8,
                      background: 'linear-gradient(135deg, #2f54eb 0%, #597ef7 100%)',
                      border: 'none',
                      width: isMobile ? '100%' : 'auto',
                      minWidth: 150
                    }}
                  >
                    {isSubmitting ? 'Enregistrement...' : 'Enregistrer la catégorie'}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default AjoutCategorie;
